import { DEFAULT_GAME_CONFIG } from "../config/gameConfig.js";

export const BOOST_MAX_ENERGY      = DEFAULT_GAME_CONFIG.boost.maxEnergy;
export const BOOST_DRAIN_RATE      = DEFAULT_GAME_CONFIG.boost.drainRate;
export const BOOST_REGEN_RATE      = DEFAULT_GAME_CONFIG.boost.regenRate;
export const BOOST_SPEED_MULTIPLIER = DEFAULT_GAME_CONFIG.boost.speedMultiplier;
export const BOOST_ACCEL_MULTIPLIER = DEFAULT_GAME_CONFIG.boost.accelMultiplier;

export interface BoostStepResult {
  energy: number;
  boosting: boolean;
}

/**
 * Advance boost energy by one tick.
 * - Drain while boosting (requested && energy > 0).
 * - Regen only when boost is NOT requested (holding boost with empty tank does not regen).
 * - Result.boosting is true only when energy was actually available.
 */
export function stepBoost(
  requested: boolean,
  energy: number,
  dt: number,
): BoostStepResult {
  if (requested && energy > 0) {
    return {
      energy: Math.max(0, energy - BOOST_DRAIN_RATE * dt),
      boosting: true,
    };
  }
  const regenEnergy = !requested
    ? Math.min(BOOST_MAX_ENERGY, energy + BOOST_REGEN_RATE * dt)
    : energy; // boost held but tank empty: stay flat until released
  return { energy: regenEnergy, boosting: false };
}
